import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaPaperPlane } from 'react-icons/fa';
import 'react-toastify/dist/ReactToastify.css';

const Calificador = ({ empleado, volver }) => {
  const [formData, setFormData] = useState({
    encontro: '',
    asesoramiento: '',
    frecuencia: '',
    calificacion: '',
    comentario: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({ ...previous, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);

    const payload = {
      empleado: empleado.nombre,
      encontro: formData.encontro,
      asesoramiento: formData.asesoramiento,
      frecuencia: formData.frecuencia,
      calificacion: formData.calificacion,
      comentario: formData.comentario
    };

    fetch('https://script.google.com/macros/s/AKfycbygz7FUedsmzVld_e3sEzWIrc5td90xnhh_MFs1QHExQyvJFtN24cypgwS5UvNUD74-/exec', {
      method: 'POST',
      body: JSON.stringify(payload)
    })
      .then(() => {
        toast.success(`Tu calificación para ${empleado.nombre} fue registrada.`, {
          position: 'top-center',
          autoClose: 3000
        });
        setTimeout(() => volver(), 1000);
      })
      .catch(() => {
        toast.error('No se pudo enviar la calificación. Intentá nuevamente.', {
          position: 'top-center',
          autoClose: 3000
        });
      })
      .finally(() => setLoading(false));
  };

  const renderOptions = (name, options) => (
    <div className={`rating-options ${options.length === 3 ? 'rating-options-three' : ''}`}>
      {options.map(({ label, value }) => (
        <label className="rating-option" key={value}>
          <input
            type="radio"
            name={name}
            value={value}
            checked={formData[name] === value}
            onChange={handleChange}
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );

  return (
    <main className="rating-page">
      <section className="rating-shell rating-form-shell" aria-labelledby="form-title">
        <header className="form-header">
          <button type="button" className="back-button" onClick={volver} disabled={loading}>
            <FaArrowLeft aria-hidden="true" />
            <span>Elegir otro vendedor</span>
          </button>

          <div className="selected-employee">
            <img src={empleado.foto} alt="" />
            <div>
              <p>Calificá la atención de</p>
              <h1 id="form-title">{empleado.nombre}</h1>
            </div>
          </div>
        </header>

        <form className="rating-form" onSubmit={handleSubmit}>
          <fieldset className="question-card">
            <legend>¿Encontraste lo que viniste a buscar?</legend>
            {renderOptions('encontro', [
              { label: 'Sí', value: 'Sí' },
              { label: 'No', value: 'No' }
            ])}
          </fieldset>

          <fieldset className="question-card">
            <legend>¿Recibiste asesoramiento sobre las ofertas del día?</legend>
            {renderOptions('asesoramiento', [
              { label: 'Sí', value: 'Sí' },
              { label: 'No', value: 'No' }
            ])}
          </fieldset>

          <fieldset className="question-card">
            <legend>¿Con qué frecuencia venís al negocio?</legend>
            {renderOptions('frecuencia', [
              { label: 'Primera vez', value: '1ra vez' },
              { label: 'Una vez por semana', value: '1 vez x semana' },
              { label: 'Una vez por mes', value: '1 vez x mes' }
            ])}
          </fieldset>

          <fieldset className="question-card">
            <legend>¿Cómo calificás la amabilidad y atención?</legend>
            <p className="question-hint">1 es la puntuación más baja y 5 la más alta.</p>
            <div className="star-rating" aria-label="Calificación de 1 a 5 estrellas">
              {[1, 2, 3, 4, 5].map((number) => (
                <label key={number} className="star-option">
                  <input
                    type="radio"
                    name="calificacion"
                    value={number}
                    checked={formData.calificacion === String(number)}
                    onChange={handleChange}
                    aria-label={`${number} ${number === 1 ? 'estrella' : 'estrellas'}`}
                  />
                  <span aria-hidden="true">
                    {number <= Number(formData.calificacion) ? '★' : '☆'}
                  </span>
                </label>
              ))}
            </div>
          </fieldset>

          <label className="comment-field">
            <span>Comentarios <small>(opcional)</small></span>
            <textarea
              rows={4}
              name="comentario"
              value={formData.comentario}
              onChange={handleChange}
              placeholder="Contanos qué podemos mejorar..."
            />
          </label>

          <div className="form-actions">
            <button type="button" className="secondary-action" onClick={volver} disabled={loading}>
              Volver
            </button>
            <button type="submit" className="primary-action" disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" aria-hidden="true" />
                  Enviando...
                </>
              ) : (
                <>
                  <FaPaperPlane aria-hidden="true" />
                  Enviar calificación
                </>
              )}
            </button>
          </div>
        </form>
      </section>
    </main>
  );
};

export default Calificador;
